import {
  ProductOfferCard as ProductOfferCardType,
  VxlActionTypenames,
} from '@varo/graphql-schema-types';
import { Href, useRouter } from 'expo-router';
import { StyleSheet, View } from 'react-native';
import ProductOfferCard from 'shared/components/vxl/cards/ProductOfferCard/ProductOfferCard';
import { IllustrationKeyType } from 'shared/components/vxl/Illustration/Illustration';
import theme from 'shared/styles/theme';
import { getVXLColor } from 'shared/utils/getVXLColor/getVXLColor';

interface MoveMoneyHeaderCardProps {
  headerCard: ProductOfferCardType;
  onHeaderPress: () => void;
}

const MoveMoneyHeaderCard = ({
  headerCard,
  onHeaderPress,
}: MoveMoneyHeaderCardProps) => {
  const router = useRouter();
  return (
    <View style={styles.productOfferWrapper}>
      <ProductOfferCard
        titleText={headerCard.titleText ?? ''}
        bodyText={headerCard.bodyText ?? ''}
        buttonText={headerCard.actionTextV2 ?? ''}
        illustrationKey={headerCard.illustrationKey as IllustrationKeyType}
        onPress={() => {
          if (!headerCard.onClickV2) {
            return null;
          }
          onHeaderPress();
          if (
            headerCard.onClickV2.__typename ===
            VxlActionTypenames.RouteNavigationAction
          ) {
            const route: Href = headerCard.onClickV2.route as Href;
            router.push(route);
          }
        }}
        hasBorder
        illustrationBackgroundColor={getVXLColor(
          headerCard.imageBackgroundColor || 'EXPRESSIVE_LIGHT',
        )}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  productOfferWrapper: {
    padding: theme.spacing.m,
  },
});

export default MoveMoneyHeaderCard;
